import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxBaseUiOptions } from "../dx-base-ui-options";
/**
 * Класс опций элемента шапки страницы.
 * @publicApi
 */
let DxPageHeaderItemOptions = class DxPageHeaderItemOptions extends DxBaseUiOptions {
    /**
     * Класс опций элемента шапки страницы.
     * @publicApi
     */
    constructor() {
        super(...arguments);
        /**
         * Порядок следования элемента шапки страницы.
         * @name _ord
         * @type {number}
         * @defaultValue - 0
         */
        this._ord = 0;
        /**
         * Флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
         * @name _addSeparatorAfter
         * @type {boolean}
         * @defaultValue - `false`
         */
        this._addSeparatorAfter = false;
    }
    /**
     * Возвращает cтроковый идент элемента шапки страницы.
     * @return {string} - cтроковый идент элемента шапки страницы.
     * @public
     */
    get ident() {
        return this._ident;
    }
    /**
     * Устанавливает cтроковый идент элемента шапки страницы.
     * @param {string} value - cтроковый идент элемента шапки страницы.
     * @public
     */
    set ident(value) {
        this._ident = value;
    }
    /**
     * Возвращает тип элемента шапки страницы.
     * @return {string} - cтроковый идент элемента шапки страницы.
     * @public
     */
    get type() {
        return this._type;
    }
    /**
     * Устанавливает тип элемента шапки страницы.
     * @param {string} value - типа элемента шапки страницы.
     * @public
     */
    set type(value) {
        this._type = value;
    }
    /**
     * Возвращает относительный путь до иконки элемента шапки страницы.
     * @return {string} - относительный путь до иконки элемента шапки страницы.
     * @public
     */
    get iconPath() {
        return this._iconPath;
    }
    /**
     * Устанавливает относительный путь до иконки элемента шапки страницы.
     * @param {string} value - относительный путь до иконки элемента шапки страницы.
     * @public
     */
    set iconPath(value) {
        this._iconPath = value;
    }
    /**
     * Возвращает иконку элемента шапки страницы, свернутую в base64.
     * @return {string} - иконка элемента шапки страницы, свернутая в base64.
     * @public
     */
    get iconBase64() {
        return this._iconBase64;
    }
    /**
     * Устанавливает иконку элемента шапки страницы, свернутую в base64.
     * @param {string} value - иконка элемента шапки страницы, свернутая в base64.
     * @public
     */
    set iconBase64(value) {
        this._iconBase64 = value;
    }
    /**
     * Возвращает порядок следования элемента шапки страницы.
     * @return {number} - порядок следования элемента шапки страницы.
     * @public
     */
    get ord() {
        return this._ord;
    }
    /**
     * Устанавливает порядок следования элемента шапки страницы.
     * @param {string} value - порядок следования элемента шапки страницы.
     * @public
     */
    set ord(value) {
        this._ord = value;
    }
    /**
     * Возвращает многострочное название виджета.
     * @return {string[]} - массив частями названия виджета, которые нужно вывести построково.
     * @public
     */
    get multiLineTitle() {
        return this._multiLineTitle;
    }
    /**
     * Устанавливает многострочное название виджета.
     * @param {string[]} value - массив частями названия виджета, которые нужно вывести построково.
     * @public
     */
    set multiLineTitle(value) {
        this._multiLineTitle = value;
    }
    /**
     * Возвращает флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
     * @return {boolean} - флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
     * @public
     */
    get addSeparatorAfter() {
        return this._addSeparatorAfter;
    }
    /**
     * Устанавливает флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
     * @param {string} value - флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
     * @public
     */
    set addSeparatorAfter(value) {
        this._addSeparatorAfter = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxPageHeaderItemOptions.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxPageHeaderItemOptions.prototype, "_type", void 0);
tslib_1.__decorate([
    jsonMember({ name: "iconPath", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxPageHeaderItemOptions.prototype, "_iconPath", void 0);
tslib_1.__decorate([
    jsonMember({ name: "iconBase64", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxPageHeaderItemOptions.prototype, "_iconBase64", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxPageHeaderItemOptions.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: "multiLineTitle", emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageHeaderItemOptions.prototype, "_multiLineTitle", void 0);
tslib_1.__decorate([
    jsonMember({ name: "addSeparatorAfter", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxPageHeaderItemOptions.prototype, "_addSeparatorAfter", void 0);
DxPageHeaderItemOptions = tslib_1.__decorate([
    jsonObject
], DxPageHeaderItemOptions);
export { DxPageHeaderItemOptions };
